import styled from 'styled-components';

const GallerySubtitle = styled.p`
	padding: ${(props) => props.theme.spacing(12)};
	padding-top: 0;
	text-align: center;
`;

export default GallerySubtitle;
